import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Login from "./pages/auth/Login";
import MainLayout from "./components/layout/MainLayout";
import ResetPassword from "./pages/auth/ResetPassword";
import { PublicRoute } from "./components/common/PublicRoute";
import HomeRedirect from "./components/common/HomeRedirect";
import ProtectedRoute from "components/common/ProtectedRoute";

import MasterList from "./pages/masters/MasterList";
import PortfolioList from "./pages/portfolio/PortfolioList";
import PortfolioAddEdit from "./pages/portfolio/PortfolioAddEdit";
import CaseStudyList from "./pages/case-studies/CaseStudyList";
import CaseStudyForm from "./pages/case-studies/CaseStudyForm";
import BlogList from "./pages/blogs/BlogList";
import BlogForm from "./pages/blogs/BlogForm";
import PageList from "./pages/pages/PageList";
import PageForm from "./pages/pages/PageForm";
import PageReorder from "./pages/pages/PageReorder";
import ContactList from "./pages/contacts/ContactList";
import RolesPage from "./pages/access/RolesPage";
import AdminUsersPage from "./pages/access/AdminUsersPage";
import AccessDenied from "./pages/common/AccessDenied";

function App() {
  return (
    <AuthProvider>
        <Router>
          <Toaster position="top-center" richColors expand={false} />
          <Routes>
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* Public Routes */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route path="/" element={<HomeRedirect />} />
            <Route
              path="/access-denied"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <AccessDenied />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            {/* Protected Routes with Layout */}


            <Route
              path="/masters/:type"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <MasterList />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/portfolio"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PortfolioList />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/portfolio/add"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PortfolioAddEdit />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/portfolio/edit/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PortfolioAddEdit />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/case-studies"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CaseStudyList />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/blogs"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <BlogList />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/blogs/add"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <BlogForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/blogs/edit/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <BlogForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/case-studies/add"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CaseStudyForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/case-studies/edit/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <CaseStudyForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />


            <Route
              path="/contacts"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <ContactList />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/pages"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PageList />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/pages/reorder"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PageReorder />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/pages/add"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PageForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/pages/edit/:id"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <PageForm />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/roles"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <RolesPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin-users"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <AdminUsersPage />
                  </MainLayout>
                </ProtectedRoute>
              }
            />


            {/* Catch all - redirect to login */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
    </AuthProvider>
  );
}

export default App;
